import React from "react";

const natureConfig = {
  perishable: {
    label: "Perishable",
    color: "#F59E0B", // amber
    icon: "⏳",
  },
  non_perishable: {
    label: "Non-Perishable",
    color: "#10B981", // green
    icon: "📦",
  },
  fragile: {
    label: "Fragile",
    color: "#3B82F6", // blue
    icon: "🧊",
  },
  hazardous: {
    label: "Hazardous",
    color: "#EF4444", // red
    icon: "☣️",
  },
};

const ProductNatureBadge = ({ nature }) => {
  const config = natureConfig[nature];

  if (!config) return null;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        height:"28px",
        gap: "6px",
        padding: "0px 10px",
        fontSize: "12px",
        fontWeight: 600,
        // borderRadius: "999px",
        // backgroundColor: `${config.color}20`,
        color: config.color,
        // border: `1px solid ${config.color}`,
      }}
    >
      <span>{config.icon}</span>
      {config.label}
    </span>
  );
};

export default ProductNatureBadge;
